import React, { memo } from "react";
import { VscLayers, VscLayersActive, VscLayersDot } from "react-icons/vsc";
import { FaRegCircleCheck } from "react-icons/fa6";
import styles from "../table.module.scss";
import { globalStatusChange } from "../../../../store/slices/tableStatusChange";
import { useDispatch, useSelector } from "react-redux";

const StatusTab = ({
  hideStatusTab = false,
  showLimitDropdown = false,
  limit = 5,
  onLimitChange = () => {},
}) => {
  const dispatch = useDispatch();
  const { tabIndex } = useSelector((state) => state.tableStatusChange);

  const statusHead = [
    { name: "All", bgColor: "#369dc9", icon: <VscLayers /> },
    { name: "Active", bgColor: "#2bc155", icon: <VscLayersActive /> },
    { name: "Inactive", bgColor: "#ffb800", icon: <VscLayersDot /> },
  ];

  // if (hideStatusTab) return null;

  return (
    <div className={styles.TabWrapper}>
      {showLimitDropdown && (
        <div className={styles.limitBox}>
          <span className={styles.limitTitle}>Number of Row :</span>

          <select
            className={styles.limitDropdown}
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
          >
            {[5, 10, 15, 20, 30, 40, 50].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* <div className={styles.TabContainer}>
        {statusHead.map((item, index) => (
          <p
            key={index}
            className={styles.tab}
            onClick={() => dispatch(globalStatusChange(index))}
            style={{ backgroundColor: item.bgColor }}
          >
            {item.icon} {item.name}
            {tabIndex === index && (
              <FaRegCircleCheck className={styles.check} />
            )}
          </p>
        ))}
      </div> */}
      {!hideStatusTab && (
        <div className={styles.TabContainer}>
          {statusHead.map((item, index) => (
            <p
              key={index}
              className={styles.tab}
              onClick={() => dispatch(globalStatusChange(index))}
              style={{ backgroundColor: item.bgColor }}
            >
              {item.icon} {item.name}
              {tabIndex === index && (
                <FaRegCircleCheck className={styles.check} />
              )}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(StatusTab);
